import { AbsoluteFill, useCurrentFrame, useVideoConfig, spring, interpolate } from "remotion";
import React from "react";

// VFX: macOS Window Mockup
// Category: device-mockups · Tags: ui, mockup, macos, window, browser
const clamp = { extrapolateLeft: "clamp", extrapolateRight: "clamp" } as const;

const MacWindowMockup: React.FC<{ url?: string; scale?: number; rounded?: number }> = ({
  url = "https://claude.ai/design", scale = 0.95, rounded = 16
}) => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const p = spring({ frame, fps, config: { damping: 120, stiffness: 160 } });
  const y = interpolate(p, [0, 1], [60, 0], clamp);
  return (
    <AbsoluteFill style={{ justifyContent: "center", alignItems: "center", background: "#0a0e1a" }}>
      <div style={{
        opacity: p,
        transform: `translateY(${y}px) scale(${interpolate(p, [0, 1], [0.92, scale], clamp)})`,
        width: 620, borderRadius: rounded,
        boxShadow: "0 2px 4px rgba(0,0,0,0.6), 0 8px 24px rgba(0,0,0,0.5), 0 32px 64px rgba(0,0,0,0.4), 0 0 0 1px rgba(255,255,255,0.08)",
        overflow: "hidden", background: "#1c1c1e"
      }}>
        <div style={{ height: 44, background: "#2c2c2e", display: "flex", alignItems: "center", padding: "0 16px", gap: 8, flexShrink: 0 }}>
          {["#ff5f57", "#ffbd2e", "#28c840"].map((c, i) => (
            <div key={i} style={{ width: 14, height: 14, borderRadius: "50%", background: c }} />
          ))}
          <div style={{
            flex: 1, margin: "0 60px", height: 28, borderRadius: 6, background: "rgba(255,255,255,0.08)",
            display: "flex", alignItems: "center", justifyContent: "center"
          }}>
            <span style={{ fontSize: 12, color: "rgba(255,255,255,0.5)", fontFamily: "system-ui" }}>{url}</span>
          </div>
        </div>
        <div style={{
          height: 400,
          background: "linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)",
          display: "flex", alignItems: "center", justifyContent: "center"
        }}>
          <span style={{ color: "rgba(255,255,255,0.4)", fontSize: 18, fontFamily: "system-ui", fontWeight: 600 }}>Screenshot</span>
        </div>
      </div>
    </AbsoluteFill>
  );
};

export default function UiMacWindowMockup800Ms() {
  return <MacWindowMockup />;
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
